<div class="top-bar">
	<div class="logo"><img id="logo" alt="Crown X" src="../../../assets/images/cds-logo-horizontal.png" /></div>
	<div class="logo-vertical-rule"><div>&nbsp;</div></div>
	<h1 id="page-title">{{Title}}</h1>
	<div class="notification-and-user-info-section">
		<div class="authorization-info" *ngIf="IsAuthenticated">
			<div class="user-and-company-name">
				<div class="username" id="username">{{UserName}}</div>
				<div *ngIf="CompanyName" class="company-name" id="company-name">{{CompanyName}}</div>
			</div>
			<crownx-user-menu
				[IsSwitchVisible]="HasMultipleCrownIds"
				(SwitchClick)="ChangeCompany()"
				(LogoutClick)="Logout()"
			></crownx-user-menu>
		</div>
		<crownx-background-operations-drawer></crownx-background-operations-drawer>
	</div>
</div>